var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.74,
    height: 78.74,
    viewBox: "0 0 78.74 78.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9679",
    "data-name": "Group 9679",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M5288.135,3203.024a18.014,18.014,0,0,0-17.957,16.169,16.692,16.692,0,0,0-.091,1.738,17.738,17.738,0,0,0,3.435,10.5l-2.248,6.653,6.933-2.211a18.063,18.063,0,0,0,27.977-14.944c0-.473-.021-.934-.061-1.4A18.013,18.013,0,0,0,5288.135,3203.024Zm10.529,25.293c-.429,1.226-2.579,2.4-3.546,2.482s-.963.785-6.318-1.3c-5.347-2.1-8.726-7.547-8.988-7.888a11.966,11.966,0,0,1-1.877-3.616,6.777,6.777,0,0,1-.272-1.781,5.851,5.851,0,0,1,1.839-4.361,1.948,1.948,0,0,1,1.409-.652c.352,0,.7.051,1.005.051s.752-.182,1.185.862,1.5,3.618,1.627,3.879a.939.939,0,0,1,.04.915,6.559,6.559,0,0,1-.333.623c-.06.08-.118.161-.189.251-.271.3-.552.674-.793.914-.26.263-.534.543-.232,1.067a15.528,15.528,0,0,0,2.925,3.606,14.219,14.219,0,0,0,4.23,2.594c.53.262.833.221,1.145-.131s1.319-1.517,1.667-2.04.706-.442,1.188-.261,3.062,1.436,3.6,1.7.872.393,1,.6A4.321,4.321,0,0,1,5298.664,3228.317Z",
    transform: "translate(-5248.223 -3183.913)",
    fill: "#25d366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M5284.276,3181a39.37,39.37,0,1,0,39.369,39.369A39.367,39.367,0,0,0,5284.276,3181Zm.52,59.288a22.352,22.352,0,0,1-10.8-2.764l-12.385,3.936,4.028-11.9a22,22,0,0,1-3.2-11.46c0-.325.01-.649.021-.973a22.363,22.363,0,0,1,44.685.409c.007.187.007.375.007.564A22.269,22.269,0,0,1,5284.8,3240.288Z",
    transform: "translate(-5244.905 -3181)",
    fill: "#25d366"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.86817996fd7ca6c489ec5820b156a24b.svg";
export { ForwardRef as ReactComponent };